/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoginShikharRouteImport } from './routes/loginShikhar'
import { Route as PaytmRouteRouteImport } from './routes/paytm/route'
import { Route as ShikharRouteRouteImport } from './routes/shikhar/route'
import { Route as URouteRouteImport } from './routes/u/route'
import { Route as AuthManageRouteImport } from './routes/_auth/manage'
import { Route as AuthReportsRouteImport } from './routes/_auth/reports'
import { Route as AuthSlotsRouteImport } from './routes/_auth/slots'
import { Route as AuthSupportRouteImport } from './routes/_auth/support'
import { Route as AuthSurgeRouteImport } from './routes/_auth/surge'
import { Route as AuthWalletRouteImport } from './routes/_auth/wallet'
import { Route as PaytmHelpRouteImport } from './routes/paytm/help'
import { Route as PaytmNeworderRouteRouteImport } from './routes/paytm/neworder/route'
import { Route as PaytmProfileRouteImport } from './routes/paytm/profile'
import { Route as ShikharHelpRouteImport } from './routes/shikhar/help'
import { Route as ShikharNeworderRouteRouteImport } from './routes/shikhar/neworder/route'
import { Route as ShikharProfileRouteImport } from './routes/shikhar/profile'
import { Route as UIndexRouteImport } from './routes/u/index'
import { Route as AuthGigsIndexRouteImport } from './routes/_auth/gigs/index'
import { Route as AuthGigsGigIdRouteImport } from './routes/_auth/gigs/$gigId'
import { Route as AuthIssuesIndexRouteImport } from './routes/_auth/issues/index'
import { Route as AuthIssuesIssueIdRouteImport } from './routes/_auth/issues/$issueId'
import { Route as AuthOrdersIndexRouteImport } from './routes/_auth/orders/index'
import { Route as AuthOrdersOrderIdRouteImport } from './routes/_auth/orders/$orderId'
import { Route as AuthOrdersAdd_orderRouteImport } from './routes/_auth/orders/add_order'
import { Route as AuthOrdersBulk_orderRouteImport } from './routes/_auth/orders/bulk_order'
import { Route as AuthReportsLspRouteImport } from './routes/_auth/reports.lsp'
import { Route as AuthTrackOrderIdRouteImport } from './routes/_auth/track/$orderId'
import { Route as PaytmNeworderConfirmRouteImport } from './routes/paytm/neworder/confirm'
import { Route as PaytmNeworderDeliveryOptionsRouteImport } from './routes/paytm/neworder/delivery-options'
import { Route as PaytmNeworderLocationRouteImport } from './routes/paytm/neworder/location'
import { Route as PaytmOrdersIndexRouteImport } from './routes/paytm/orders/index'
import { Route as PaytmOrdersOrderIdRouteImport } from './routes/paytm/orders/$orderId'
import { Route as ShikharIssuesIndexRouteImport } from './routes/shikhar/issues/index'
import { Route as ShikharIssuesIssueIdRouteImport } from './routes/shikhar/issues/$issueId'
import { Route as ShikharNeworderConfirmRouteImport } from './routes/shikhar/neworder/confirm'
import { Route as ShikharNeworderDeliveryOptionsRouteImport } from './routes/shikhar/neworder/delivery-options'
import { Route as ShikharNeworderLocationRouteImport } from './routes/shikhar/neworder/location'
import { Route as ShikharOrdersIndexRouteImport } from './routes/shikhar/orders/index'
import { Route as ShikharOrdersOrderIdRouteImport } from './routes/shikhar/orders/$orderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginShikharRoute = LoginShikharRouteImport.update({
  id: '/loginShikhar',
  path: '/loginShikhar',
  getParentRoute: () => rootRouteImport,
} as any)
const PaytmRouteRoute = PaytmRouteRouteImport.update({
  id: '/paytm',
  path: '/paytm',
  getParentRoute: () => rootRouteImport,
} as any)
const ShikharRouteRoute = ShikharRouteRouteImport.update({
  id: '/shikhar',
  path: '/shikhar',
  getParentRoute: () => rootRouteImport,
} as any)
const URouteRoute = URouteRouteImport.update({
  id: '/u',
  path: '/u',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthManageRoute = AuthManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSlotsRoute = AuthSlotsRouteImport.update({
  id: '/slots',
  path: '/slots',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSupportRoute = AuthSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSurgeRoute = AuthSurgeRouteImport.update({
  id: '/surge',
  path: '/surge',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthWalletRoute = AuthWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => AuthRouteRoute,
} as any)
const PaytmHelpRoute = PaytmHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => PaytmRouteRoute,
} as any)
const PaytmNeworderRouteRoute = PaytmNeworderRouteRouteImport.update({
  id: '/neworder',
  path: '/neworder',
  getParentRoute: () => PaytmRouteRoute,
} as any)
const PaytmProfileRoute = PaytmProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PaytmRouteRoute,
} as any)
const ShikharHelpRoute = ShikharHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => ShikharRouteRoute,
} as any)
const ShikharNeworderRouteRoute = ShikharNeworderRouteRouteImport.update({
  id: '/neworder',
  path: '/neworder',
  getParentRoute: () => ShikharRouteRoute,
} as any)
const ShikharProfileRoute = ShikharProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ShikharRouteRoute,
} as any)
const UIndexRoute = UIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => URouteRoute,
} as any)
const AuthGigsIndexRoute = AuthGigsIndexRouteImport.update({
  id: '/gigs/',
  path: '/gigs/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthGigsGigIdRoute = AuthGigsGigIdRouteImport.update({
  id: '/gigs/$gigId',
  path: '/gigs/$gigId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthIssuesIndexRoute = AuthIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthIssuesIssueIdRoute = AuthIssuesIssueIdRouteImport.update({
  id: '/issues/$issueId',
  path: '/issues/$issueId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrdersIndexRoute = AuthOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrdersOrderIdRoute = AuthOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrdersAdd_orderRoute = AuthOrdersAdd_orderRouteImport.update({
  id: '/orders/add_order',
  path: '/orders/add_order',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrdersBulk_orderRoute = AuthOrdersBulk_orderRouteImport.update({
  id: '/orders/bulk_order',
  path: '/orders/bulk_order',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthReportsLspRoute = AuthReportsLspRouteImport.update({
  id: '/lsp',
  path: '/lsp',
  getParentRoute: () => AuthReportsRoute,
} as any)
const AuthTrackOrderIdRoute = AuthTrackOrderIdRouteImport.update({
  id: '/track/$orderId',
  path: '/track/$orderId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const PaytmNeworderConfirmRoute = PaytmNeworderConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => PaytmNeworderRouteRoute,
} as any)
const PaytmNeworderDeliveryOptionsRoute =
  PaytmNeworderDeliveryOptionsRouteImport.update({
    id: '/delivery-options',
    path: '/delivery-options',
    getParentRoute: () => PaytmNeworderRouteRoute,
  } as any)
const PaytmNeworderLocationRoute = PaytmNeworderLocationRouteImport.update({
  id: '/location',
  path: '/location',
  getParentRoute: () => PaytmNeworderRouteRoute,
} as any)
const PaytmOrdersIndexRoute = PaytmOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => PaytmRouteRoute,
} as any)
const PaytmOrdersOrderIdRoute = PaytmOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => PaytmRouteRoute,
} as any)
const ShikharIssuesIndexRoute = ShikharIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => ShikharRouteRoute,
} as any)
const ShikharIssuesIssueIdRoute = ShikharIssuesIssueIdRouteImport.update({
  id: '/issues/$issueId',
  path: '/issues/$issueId',
  getParentRoute: () => ShikharRouteRoute,
} as any)
const ShikharNeworderConfirmRoute = ShikharNeworderConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => ShikharNeworderRouteRoute,
} as any)
const ShikharNeworderDeliveryOptionsRoute =
  ShikharNeworderDeliveryOptionsRouteImport.update({
    id: '/delivery-options',
    path: '/delivery-options',
    getParentRoute: () => ShikharNeworderRouteRoute,
  } as any)
const ShikharNeworderLocationRoute = ShikharNeworderLocationRouteImport.update({
  id: '/location',
  path: '/location',
  getParentRoute: () => ShikharNeworderRouteRoute,
} as any)
const ShikharOrdersIndexRoute = ShikharOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => ShikharRouteRoute,
} as any)
const ShikharOrdersOrderIdRoute = ShikharOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => ShikharRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/paytm': typeof PaytmRouteRouteWithChildren
  '/shikhar': typeof ShikharRouteRouteWithChildren
  '/u': typeof URouteRouteWithChildren
  '/login': typeof LoginRoute
  '/loginShikhar': typeof LoginShikharRoute
  '/paytm/neworder': typeof PaytmNeworderRouteRouteWithChildren
  '/shikhar/neworder': typeof ShikharNeworderRouteRouteWithChildren
  '/manage': typeof AuthManageRoute
  '/reports': typeof AuthReportsRouteWithChildren
  '/slots': typeof AuthSlotsRoute
  '/support': typeof AuthSupportRoute
  '/surge': typeof AuthSurgeRoute
  '/wallet': typeof AuthWalletRoute
  '/paytm/help': typeof PaytmHelpRoute
  '/paytm/profile': typeof PaytmProfileRoute
  '/shikhar/help': typeof ShikharHelpRoute
  '/shikhar/profile': typeof ShikharProfileRoute
  '/u/': typeof UIndexRoute
  '/gigs/$gigId': typeof AuthGigsGigIdRoute
  '/issues/$issueId': typeof AuthIssuesIssueIdRoute
  '/orders/$orderId': typeof AuthOrdersOrderIdRoute
  '/orders/add_order': typeof AuthOrdersAdd_orderRoute
  '/orders/bulk_order': typeof AuthOrdersBulk_orderRoute
  '/reports/lsp': typeof AuthReportsLspRoute
  '/track/$orderId': typeof AuthTrackOrderIdRoute
  '/paytm/neworder/confirm': typeof PaytmNeworderConfirmRoute
  '/paytm/neworder/delivery-options': typeof PaytmNeworderDeliveryOptionsRoute
  '/paytm/neworder/location': typeof PaytmNeworderLocationRoute
  '/paytm/orders/$orderId': typeof PaytmOrdersOrderIdRoute
  '/shikhar/issues/$issueId': typeof ShikharIssuesIssueIdRoute
  '/shikhar/neworder/confirm': typeof ShikharNeworderConfirmRoute
  '/shikhar/neworder/delivery-options': typeof ShikharNeworderDeliveryOptionsRoute
  '/shikhar/neworder/location': typeof ShikharNeworderLocationRoute
  '/shikhar/orders/$orderId': typeof ShikharOrdersOrderIdRoute
  '/gigs/': typeof AuthGigsIndexRoute
  '/issues/': typeof AuthIssuesIndexRoute
  '/orders/': typeof AuthOrdersIndexRoute
  '/paytm/orders/': typeof PaytmOrdersIndexRoute
  '/shikhar/issues/': typeof ShikharIssuesIndexRoute
  '/shikhar/orders/': typeof ShikharOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/paytm': typeof PaytmRouteRouteWithChildren
  '/shikhar': typeof ShikharRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/loginShikhar': typeof LoginShikharRoute
  '/paytm/neworder': typeof PaytmNeworderRouteRouteWithChildren
  '/shikhar/neworder': typeof ShikharNeworderRouteRouteWithChildren
  '/manage': typeof AuthManageRoute
  '/reports': typeof AuthReportsRouteWithChildren
  '/slots': typeof AuthSlotsRoute
  '/support': typeof AuthSupportRoute
  '/surge': typeof AuthSurgeRoute
  '/wallet': typeof AuthWalletRoute
  '/paytm/help': typeof PaytmHelpRoute
  '/paytm/profile': typeof PaytmProfileRoute
  '/shikhar/help': typeof ShikharHelpRoute
  '/shikhar/profile': typeof ShikharProfileRoute
  '/u': typeof UIndexRoute
  '/gigs/$gigId': typeof AuthGigsGigIdRoute
  '/issues/$issueId': typeof AuthIssuesIssueIdRoute
  '/orders/$orderId': typeof AuthOrdersOrderIdRoute
  '/orders/add_order': typeof AuthOrdersAdd_orderRoute
  '/orders/bulk_order': typeof AuthOrdersBulk_orderRoute
  '/reports/lsp': typeof AuthReportsLspRoute
  '/track/$orderId': typeof AuthTrackOrderIdRoute
  '/paytm/neworder/confirm': typeof PaytmNeworderConfirmRoute
  '/paytm/neworder/delivery-options': typeof PaytmNeworderDeliveryOptionsRoute
  '/paytm/neworder/location': typeof PaytmNeworderLocationRoute
  '/paytm/orders/$orderId': typeof PaytmOrdersOrderIdRoute
  '/shikhar/issues/$issueId': typeof ShikharIssuesIssueIdRoute
  '/shikhar/neworder/confirm': typeof ShikharNeworderConfirmRoute
  '/shikhar/neworder/delivery-options': typeof ShikharNeworderDeliveryOptionsRoute
  '/shikhar/neworder/location': typeof ShikharNeworderLocationRoute
  '/shikhar/orders/$orderId': typeof ShikharOrdersOrderIdRoute
  '/gigs': typeof AuthGigsIndexRoute
  '/issues': typeof AuthIssuesIndexRoute
  '/orders': typeof AuthOrdersIndexRoute
  '/paytm/orders': typeof PaytmOrdersIndexRoute
  '/shikhar/issues': typeof ShikharIssuesIndexRoute
  '/shikhar/orders': typeof ShikharOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/paytm': typeof PaytmRouteRouteWithChildren
  '/shikhar': typeof ShikharRouteRouteWithChildren
  '/u': typeof URouteRouteWithChildren
  '/login': typeof LoginRoute
  '/loginShikhar': typeof LoginShikharRoute
  '/paytm/neworder': typeof PaytmNeworderRouteRouteWithChildren
  '/shikhar/neworder': typeof ShikharNeworderRouteRouteWithChildren
  '/_auth/manage': typeof AuthManageRoute
  '/_auth/reports': typeof AuthReportsRouteWithChildren
  '/_auth/slots': typeof AuthSlotsRoute
  '/_auth/support': typeof AuthSupportRoute
  '/_auth/surge': typeof AuthSurgeRoute
  '/_auth/wallet': typeof AuthWalletRoute
  '/paytm/help': typeof PaytmHelpRoute
  '/paytm/profile': typeof PaytmProfileRoute
  '/shikhar/help': typeof ShikharHelpRoute
  '/shikhar/profile': typeof ShikharProfileRoute
  '/u/': typeof UIndexRoute
  '/_auth/gigs/$gigId': typeof AuthGigsGigIdRoute
  '/_auth/issues/$issueId': typeof AuthIssuesIssueIdRoute
  '/_auth/orders/$orderId': typeof AuthOrdersOrderIdRoute
  '/_auth/orders/add_order': typeof AuthOrdersAdd_orderRoute
  '/_auth/orders/bulk_order': typeof AuthOrdersBulk_orderRoute
  '/_auth/reports/lsp': typeof AuthReportsLspRoute
  '/_auth/track/$orderId': typeof AuthTrackOrderIdRoute
  '/paytm/neworder/confirm': typeof PaytmNeworderConfirmRoute
  '/paytm/neworder/delivery-options': typeof PaytmNeworderDeliveryOptionsRoute
  '/paytm/neworder/location': typeof PaytmNeworderLocationRoute
  '/paytm/orders/$orderId': typeof PaytmOrdersOrderIdRoute
  '/shikhar/issues/$issueId': typeof ShikharIssuesIssueIdRoute
  '/shikhar/neworder/confirm': typeof ShikharNeworderConfirmRoute
  '/shikhar/neworder/delivery-options': typeof ShikharNeworderDeliveryOptionsRoute
  '/shikhar/neworder/location': typeof ShikharNeworderLocationRoute
  '/shikhar/orders/$orderId': typeof ShikharOrdersOrderIdRoute
  '/_auth/gigs/': typeof AuthGigsIndexRoute
  '/_auth/issues/': typeof AuthIssuesIndexRoute
  '/_auth/orders/': typeof AuthOrdersIndexRoute
  '/paytm/orders/': typeof PaytmOrdersIndexRoute
  '/shikhar/issues/': typeof ShikharIssuesIndexRoute
  '/shikhar/orders/': typeof ShikharOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/paytm'
    | '/shikhar'
    | '/u'
    | '/login'
    | '/loginShikhar'
    | '/paytm/neworder'
    | '/shikhar/neworder'
    | '/manage'
    | '/reports'
    | '/slots'
    | '/support'
    | '/surge'
    | '/wallet'
    | '/paytm/help'
    | '/paytm/profile'
    | '/shikhar/help'
    | '/shikhar/profile'
    | '/u/'
    | '/gigs/$gigId'
    | '/issues/$issueId'
    | '/orders/$orderId'
    | '/orders/add_order'
    | '/orders/bulk_order'
    | '/reports/lsp'
    | '/track/$orderId'
    | '/paytm/neworder/confirm'
    | '/paytm/neworder/delivery-options'
    | '/paytm/neworder/location'
    | '/paytm/orders/$orderId'
    | '/shikhar/issues/$issueId'
    | '/shikhar/neworder/confirm'
    | '/shikhar/neworder/delivery-options'
    | '/shikhar/neworder/location'
    | '/shikhar/orders/$orderId'
    | '/gigs/'
    | '/issues/'
    | '/orders/'
    | '/paytm/orders/'
    | '/shikhar/issues/'
    | '/shikhar/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/paytm'
    | '/shikhar'
    | '/login'
    | '/loginShikhar'
    | '/paytm/neworder'
    | '/shikhar/neworder'
    | '/manage'
    | '/reports'
    | '/slots'
    | '/support'
    | '/surge'
    | '/wallet'
    | '/paytm/help'
    | '/paytm/profile'
    | '/shikhar/help'
    | '/shikhar/profile'
    | '/u'
    | '/gigs/$gigId'
    | '/issues/$issueId'
    | '/orders/$orderId'
    | '/orders/add_order'
    | '/orders/bulk_order'
    | '/reports/lsp'
    | '/track/$orderId'
    | '/paytm/neworder/confirm'
    | '/paytm/neworder/delivery-options'
    | '/paytm/neworder/location'
    | '/paytm/orders/$orderId'
    | '/shikhar/issues/$issueId'
    | '/shikhar/neworder/confirm'
    | '/shikhar/neworder/delivery-options'
    | '/shikhar/neworder/location'
    | '/shikhar/orders/$orderId'
    | '/gigs'
    | '/issues'
    | '/orders'
    | '/paytm/orders'
    | '/shikhar/issues'
    | '/shikhar/orders'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/paytm'
    | '/shikhar'
    | '/u'
    | '/login'
    | '/loginShikhar'
    | '/paytm/neworder'
    | '/shikhar/neworder'
    | '/_auth/manage'
    | '/_auth/reports'
    | '/_auth/slots'
    | '/_auth/support'
    | '/_auth/surge'
    | '/_auth/wallet'
    | '/paytm/help'
    | '/paytm/profile'
    | '/shikhar/help'
    | '/shikhar/profile'
    | '/u/'
    | '/_auth/gigs/$gigId'
    | '/_auth/issues/$issueId'
    | '/_auth/orders/$orderId'
    | '/_auth/orders/add_order'
    | '/_auth/orders/bulk_order'
    | '/_auth/reports/lsp'
    | '/_auth/track/$orderId'
    | '/paytm/neworder/confirm'
    | '/paytm/neworder/delivery-options'
    | '/paytm/neworder/location'
    | '/paytm/orders/$orderId'
    | '/shikhar/issues/$issueId'
    | '/shikhar/neworder/confirm'
    | '/shikhar/neworder/delivery-options'
    | '/shikhar/neworder/location'
    | '/shikhar/orders/$orderId'
    | '/_auth/gigs/'
    | '/_auth/issues/'
    | '/_auth/orders/'
    | '/paytm/orders/'
    | '/shikhar/issues/'
    | '/shikhar/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PaytmRouteRoute: typeof PaytmRouteRouteWithChildren
  ShikharRouteRoute: typeof ShikharRouteRouteWithChildren
  URouteRoute: typeof URouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  LoginShikharRoute: typeof LoginShikharRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loginShikhar': {
      id: '/loginShikhar'
      path: '/loginShikhar'
      fullPath: '/loginShikhar'
      preLoaderRoute: typeof LoginShikharRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/paytm': {
      id: '/paytm'
      path: '/paytm'
      fullPath: '/paytm'
      preLoaderRoute: typeof PaytmRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shikhar': {
      id: '/shikhar'
      path: '/shikhar'
      fullPath: '/shikhar'
      preLoaderRoute: typeof ShikharRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u': {
      id: '/u'
      path: '/u'
      fullPath: '/u'
      preLoaderRoute: typeof URouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/manage': {
      id: '/_auth/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof AuthManageRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/slots': {
      id: '/_auth/slots'
      path: '/slots'
      fullPath: '/slots'
      preLoaderRoute: typeof AuthSlotsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/support': {
      id: '/_auth/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthSupportRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/surge': {
      id: '/_auth/surge'
      path: '/surge'
      fullPath: '/surge'
      preLoaderRoute: typeof AuthSurgeRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/wallet': {
      id: '/_auth/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof AuthWalletRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/paytm/help': {
      id: '/paytm/help'
      path: '/help'
      fullPath: '/paytm/help'
      preLoaderRoute: typeof PaytmHelpRouteImport
      parentRoute: typeof PaytmRouteRoute
    }
    '/paytm/neworder': {
      id: '/paytm/neworder'
      path: '/neworder'
      fullPath: '/paytm/neworder'
      preLoaderRoute: typeof PaytmNeworderRouteRouteImport
      parentRoute: typeof PaytmRouteRoute
    }
    '/paytm/profile': {
      id: '/paytm/profile'
      path: '/profile'
      fullPath: '/paytm/profile'
      preLoaderRoute: typeof PaytmProfileRouteImport
      parentRoute: typeof PaytmRouteRoute
    }
    '/shikhar/help': {
      id: '/shikhar/help'
      path: '/help'
      fullPath: '/shikhar/help'
      preLoaderRoute: typeof ShikharHelpRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
    '/shikhar/neworder': {
      id: '/shikhar/neworder'
      path: '/neworder'
      fullPath: '/shikhar/neworder'
      preLoaderRoute: typeof ShikharNeworderRouteRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
    '/shikhar/profile': {
      id: '/shikhar/profile'
      path: '/profile'
      fullPath: '/shikhar/profile'
      preLoaderRoute: typeof ShikharProfileRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
    '/u/': {
      id: '/u/'
      path: '/'
      fullPath: '/u/'
      preLoaderRoute: typeof UIndexRouteImport
      parentRoute: typeof URouteRoute
    }
    '/_auth/gigs/': {
      id: '/_auth/gigs/'
      path: '/gigs'
      fullPath: '/gigs/'
      preLoaderRoute: typeof AuthGigsIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/gigs/$gigId': {
      id: '/_auth/gigs/$gigId'
      path: '/gigs/$gigId'
      fullPath: '/gigs/$gigId'
      preLoaderRoute: typeof AuthGigsGigIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/issues/': {
      id: '/_auth/issues/'
      path: '/issues'
      fullPath: '/issues/'
      preLoaderRoute: typeof AuthIssuesIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/issues/$issueId': {
      id: '/_auth/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/issues/$issueId'
      preLoaderRoute: typeof AuthIssuesIssueIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/orders/': {
      id: '/_auth/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthOrdersIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/orders/$orderId': {
      id: '/_auth/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthOrdersOrderIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/orders/add_order': {
      id: '/_auth/orders/add_order'
      path: '/orders/add_order'
      fullPath: '/orders/add_order'
      preLoaderRoute: typeof AuthOrdersAdd_orderRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/orders/bulk_order': {
      id: '/_auth/orders/bulk_order'
      path: '/orders/bulk_order'
      fullPath: '/orders/bulk_order'
      preLoaderRoute: typeof AuthOrdersBulk_orderRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reports/lsp': {
      id: '/_auth/reports/lsp'
      path: '/lsp'
      fullPath: '/reports/lsp'
      preLoaderRoute: typeof AuthReportsLspRouteImport
      parentRoute: typeof AuthReportsRoute
    }
    '/_auth/track/$orderId': {
      id: '/_auth/track/$orderId'
      path: '/track/$orderId'
      fullPath: '/track/$orderId'
      preLoaderRoute: typeof AuthTrackOrderIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/paytm/neworder/confirm': {
      id: '/paytm/neworder/confirm'
      path: '/confirm'
      fullPath: '/paytm/neworder/confirm'
      preLoaderRoute: typeof PaytmNeworderConfirmRouteImport
      parentRoute: typeof PaytmNeworderRouteRoute
    }
    '/paytm/neworder/delivery-options': {
      id: '/paytm/neworder/delivery-options'
      path: '/delivery-options'
      fullPath: '/paytm/neworder/delivery-options'
      preLoaderRoute: typeof PaytmNeworderDeliveryOptionsRouteImport
      parentRoute: typeof PaytmNeworderRouteRoute
    }
    '/paytm/neworder/location': {
      id: '/paytm/neworder/location'
      path: '/location'
      fullPath: '/paytm/neworder/location'
      preLoaderRoute: typeof PaytmNeworderLocationRouteImport
      parentRoute: typeof PaytmNeworderRouteRoute
    }
    '/paytm/orders/': {
      id: '/paytm/orders/'
      path: '/orders'
      fullPath: '/paytm/orders/'
      preLoaderRoute: typeof PaytmOrdersIndexRouteImport
      parentRoute: typeof PaytmRouteRoute
    }
    '/paytm/orders/$orderId': {
      id: '/paytm/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/paytm/orders/$orderId'
      preLoaderRoute: typeof PaytmOrdersOrderIdRouteImport
      parentRoute: typeof PaytmRouteRoute
    }
    '/shikhar/issues/': {
      id: '/shikhar/issues/'
      path: '/issues'
      fullPath: '/shikhar/issues/'
      preLoaderRoute: typeof ShikharIssuesIndexRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
    '/shikhar/issues/$issueId': {
      id: '/shikhar/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/shikhar/issues/$issueId'
      preLoaderRoute: typeof ShikharIssuesIssueIdRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
    '/shikhar/neworder/confirm': {
      id: '/shikhar/neworder/confirm'
      path: '/confirm'
      fullPath: '/shikhar/neworder/confirm'
      preLoaderRoute: typeof ShikharNeworderConfirmRouteImport
      parentRoute: typeof ShikharNeworderRouteRoute
    }
    '/shikhar/neworder/delivery-options': {
      id: '/shikhar/neworder/delivery-options'
      path: '/delivery-options'
      fullPath: '/shikhar/neworder/delivery-options'
      preLoaderRoute: typeof ShikharNeworderDeliveryOptionsRouteImport
      parentRoute: typeof ShikharNeworderRouteRoute
    }
    '/shikhar/neworder/location': {
      id: '/shikhar/neworder/location'
      path: '/location'
      fullPath: '/shikhar/neworder/location'
      preLoaderRoute: typeof ShikharNeworderLocationRouteImport
      parentRoute: typeof ShikharNeworderRouteRoute
    }
    '/shikhar/orders/': {
      id: '/shikhar/orders/'
      path: '/orders'
      fullPath: '/shikhar/orders/'
      preLoaderRoute: typeof ShikharOrdersIndexRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
    '/shikhar/orders/$orderId': {
      id: '/shikhar/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/shikhar/orders/$orderId'
      preLoaderRoute: typeof ShikharOrdersOrderIdRouteImport
      parentRoute: typeof ShikharRouteRoute
    }
  }
}

interface AuthReportsRouteChildren {
  AuthReportsLspRoute: typeof AuthReportsLspRoute
}

const AuthReportsRouteChildren: AuthReportsRouteChildren = {
  AuthReportsLspRoute: AuthReportsLspRoute,
}

const AuthReportsRouteWithChildren = AuthReportsRoute._addFileChildren(
  AuthReportsRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthManageRoute: typeof AuthManageRoute
  AuthReportsRoute: typeof AuthReportsRouteWithChildren
  AuthSlotsRoute: typeof AuthSlotsRoute
  AuthSupportRoute: typeof AuthSupportRoute
  AuthSurgeRoute: typeof AuthSurgeRoute
  AuthWalletRoute: typeof AuthWalletRoute
  AuthGigsGigIdRoute: typeof AuthGigsGigIdRoute
  AuthIssuesIssueIdRoute: typeof AuthIssuesIssueIdRoute
  AuthOrdersOrderIdRoute: typeof AuthOrdersOrderIdRoute
  AuthOrdersAdd_orderRoute: typeof AuthOrdersAdd_orderRoute
  AuthOrdersBulk_orderRoute: typeof AuthOrdersBulk_orderRoute
  AuthTrackOrderIdRoute: typeof AuthTrackOrderIdRoute
  AuthGigsIndexRoute: typeof AuthGigsIndexRoute
  AuthIssuesIndexRoute: typeof AuthIssuesIndexRoute
  AuthOrdersIndexRoute: typeof AuthOrdersIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthManageRoute: AuthManageRoute,
  AuthReportsRoute: AuthReportsRouteWithChildren,
  AuthSlotsRoute: AuthSlotsRoute,
  AuthSupportRoute: AuthSupportRoute,
  AuthSurgeRoute: AuthSurgeRoute,
  AuthWalletRoute: AuthWalletRoute,
  AuthGigsGigIdRoute: AuthGigsGigIdRoute,
  AuthIssuesIssueIdRoute: AuthIssuesIssueIdRoute,
  AuthOrdersOrderIdRoute: AuthOrdersOrderIdRoute,
  AuthOrdersAdd_orderRoute: AuthOrdersAdd_orderRoute,
  AuthOrdersBulk_orderRoute: AuthOrdersBulk_orderRoute,
  AuthTrackOrderIdRoute: AuthTrackOrderIdRoute,
  AuthGigsIndexRoute: AuthGigsIndexRoute,
  AuthIssuesIndexRoute: AuthIssuesIndexRoute,
  AuthOrdersIndexRoute: AuthOrdersIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface PaytmNeworderRouteRouteChildren {
  PaytmNeworderConfirmRoute: typeof PaytmNeworderConfirmRoute
  PaytmNeworderDeliveryOptionsRoute: typeof PaytmNeworderDeliveryOptionsRoute
  PaytmNeworderLocationRoute: typeof PaytmNeworderLocationRoute
}

const PaytmNeworderRouteRouteChildren: PaytmNeworderRouteRouteChildren = {
  PaytmNeworderConfirmRoute: PaytmNeworderConfirmRoute,
  PaytmNeworderDeliveryOptionsRoute: PaytmNeworderDeliveryOptionsRoute,
  PaytmNeworderLocationRoute: PaytmNeworderLocationRoute,
}

const PaytmNeworderRouteRouteWithChildren =
  PaytmNeworderRouteRoute._addFileChildren(PaytmNeworderRouteRouteChildren)

interface PaytmRouteRouteChildren {
  PaytmNeworderRouteRoute: typeof PaytmNeworderRouteRouteWithChildren
  PaytmHelpRoute: typeof PaytmHelpRoute
  PaytmProfileRoute: typeof PaytmProfileRoute
  PaytmOrdersOrderIdRoute: typeof PaytmOrdersOrderIdRoute
  PaytmOrdersIndexRoute: typeof PaytmOrdersIndexRoute
}

const PaytmRouteRouteChildren: PaytmRouteRouteChildren = {
  PaytmNeworderRouteRoute: PaytmNeworderRouteRouteWithChildren,
  PaytmHelpRoute: PaytmHelpRoute,
  PaytmProfileRoute: PaytmProfileRoute,
  PaytmOrdersOrderIdRoute: PaytmOrdersOrderIdRoute,
  PaytmOrdersIndexRoute: PaytmOrdersIndexRoute,
}

const PaytmRouteRouteWithChildren = PaytmRouteRoute._addFileChildren(
  PaytmRouteRouteChildren,
)

interface ShikharNeworderRouteRouteChildren {
  ShikharNeworderConfirmRoute: typeof ShikharNeworderConfirmRoute
  ShikharNeworderDeliveryOptionsRoute: typeof ShikharNeworderDeliveryOptionsRoute
  ShikharNeworderLocationRoute: typeof ShikharNeworderLocationRoute
}

const ShikharNeworderRouteRouteChildren: ShikharNeworderRouteRouteChildren = {
  ShikharNeworderConfirmRoute: ShikharNeworderConfirmRoute,
  ShikharNeworderDeliveryOptionsRoute: ShikharNeworderDeliveryOptionsRoute,
  ShikharNeworderLocationRoute: ShikharNeworderLocationRoute,
}

const ShikharNeworderRouteRouteWithChildren =
  ShikharNeworderRouteRoute._addFileChildren(ShikharNeworderRouteRouteChildren)

interface ShikharRouteRouteChildren {
  ShikharNeworderRouteRoute: typeof ShikharNeworderRouteRouteWithChildren
  ShikharHelpRoute: typeof ShikharHelpRoute
  ShikharProfileRoute: typeof ShikharProfileRoute
  ShikharIssuesIssueIdRoute: typeof ShikharIssuesIssueIdRoute
  ShikharOrdersOrderIdRoute: typeof ShikharOrdersOrderIdRoute
  ShikharIssuesIndexRoute: typeof ShikharIssuesIndexRoute
  ShikharOrdersIndexRoute: typeof ShikharOrdersIndexRoute
}

const ShikharRouteRouteChildren: ShikharRouteRouteChildren = {
  ShikharNeworderRouteRoute: ShikharNeworderRouteRouteWithChildren,
  ShikharHelpRoute: ShikharHelpRoute,
  ShikharProfileRoute: ShikharProfileRoute,
  ShikharIssuesIssueIdRoute: ShikharIssuesIssueIdRoute,
  ShikharOrdersOrderIdRoute: ShikharOrdersOrderIdRoute,
  ShikharIssuesIndexRoute: ShikharIssuesIndexRoute,
  ShikharOrdersIndexRoute: ShikharOrdersIndexRoute,
}

const ShikharRouteRouteWithChildren = ShikharRouteRoute._addFileChildren(
  ShikharRouteRouteChildren,
)

interface URouteRouteChildren {
  UIndexRoute: typeof UIndexRoute
}

const URouteRouteChildren: URouteRouteChildren = {
  UIndexRoute: UIndexRoute,
}

const URouteRouteWithChildren =
  URouteRoute._addFileChildren(URouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PaytmRouteRoute: PaytmRouteRouteWithChildren,
  ShikharRouteRoute: ShikharRouteRouteWithChildren,
  URouteRoute: URouteRouteWithChildren,
  LoginRoute: LoginRoute,
  LoginShikharRoute: LoginShikharRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
